import React from 'react';
import PropTypes from 'prop-types';
import Label from '../label/label';
import styled, { css } from 'styled-components';

const EntryPickerStyled = styled.div`
  ${({ useDefaultTheme }) => {
    return css`
      ${useDefaultTheme &&
        css`
          .radio-wrapper,
          .checkbox-wrapper {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            input {
              height: auto;
              width: auto;
              margin: 0 4px 0 0;
            }
            label {
              display: inline-block;
            }
          }
        `}
    `;
  }};
`;

const EntryPicker = ({
  className,
  results,
  id,
  label,
  validations,
  type,
  useDefaultTheme,
  setValue,
  formId,
}) => {
  if (!results || results.length > 3) return null;
  const isRequired = validations && validations.required ? true : false;

  let valArr = [];
  const _handleChange = (formId, id, value, isChecked) => {
    if (type === 'checkbox') {
      if (isChecked) {
        valArr.push(value);
      } else if (!isChecked) {
        valArr = valArr.filter(valItem => valItem !== value);
      }
      setValue(formId, id, valArr);
    } else {
      setValue(formId, id, value);
    }
  };
  return (
    <EntryPickerStyled
      className={`${type}-container`}
      useDefaultTheme={useDefaultTheme}
    >
      <Label
        id={id}
        label={label}
        isRequired={isRequired}
        className={`label-${type}-container`}
      />
      {results.map((res, idx) => {
        return (
          <span key={idx} className={`${type}-wrapper`}>
            <input
              type={type}
              id={res.entryTitle}
              value={res.entryTitle}
              name={id}
              className={`${className ? className : ''} input-${type}`}
              onChange={e =>
                _handleChange(formId, id, e.target.value, e.target.checked)
              }
            />
            <Label
              id={res.entryTitle}
              label={res.entryTitle}
              className={`label-${type}`}
            />
          </span>
        );
      })}
    </EntryPickerStyled>
  );
};

EntryPicker.propTypes = {
  className: PropTypes.string,
  results: PropTypes.array,
  id: PropTypes.string,
  label: PropTypes.string,
  validations: PropTypes.object,
  type: PropTypes.string,
  useDefaultTheme: PropTypes.bool,
  setValue: PropTypes.func,
  formId: PropTypes.string,
};

export default EntryPicker;
